import { pushEvent } from '@allianz/tracking';
import { Injectable } from '@angular/core';
import { TrackService } from './track.service';

@Injectable({
    providedIn: 'root'
  })
  export class TrackingPageService {
  
    constructor(public trackService: TrackService) {}


  pageId: string;
  currentPageName: string;
  currentPage: string
  oldPage: string;
  oldPageName: string;

    trackingPage(pageName){ {
        switch (pageName) {
            case "/start": {
              this.pageId = "01.";
              this.currentPageName = "start"
              break;
            }
            case "/object-details": {
              this.pageId = "02.";
              this.currentPageName = "object-details"
              break;
            }
            case "/object-details-2": {
              this.pageId = "03.";
              this.currentPageName = "object-details-2";
              break;
            }
            case "/package-selection": {
              this.pageId = "04.";
              this.currentPageName = "package-selection";
              break;
            }
            case "/object-additional-details": {
              this.pageId = "05.";
              this.currentPageName = "object-details-3";
              break;
            }
            case "/contact-details": {
              this.pageId = "06.";
              this.currentPageName = "contact-details";
              break;
            }
            case "/summary": {
              this.pageId = "07.";
              this.currentPageName = "summary";
              break;
            }
            case "/consents": {
              this.pageId = "08.";
              this.currentPageName = "consents";
              break;
            }
            case "/payment": {
              this.pageId = "09.";
              this.currentPageName = "payment";
              break;
            }
            case "/successfulPayment": {
              this.pageId = "10.";
              this.currentPageName = "successful-payment";
              break;
            }
            case "/error": {
              this.pageId = "00.";
              this.currentPageName = "error";
              break;
            }
            // case "/call-back-form": {
            //   this.pageId = "00.";
            //   this.currentPageName = "call-back-form";
            //   break;
            // }
            // case "/call-back-form-sent": {
            //   this.pageId = "00.";
            //   this.currentPageName = "call-back-form-sent";
            //   break;
            //}
            default: {
              this.pageId = null;
              break;
            }
          }
    
        this.currentPage = pageName;
    
        if (
          this.oldPage !== this.pageId &&
          this.oldPage !== '' &&
          this.oldPageName !== '' &&
          this.oldPage !== undefined &&
          this.oldPageName !== undefined
        ) {
          // pushEvent('previousStepNumber', this.oldPage, true);
          // pushEvent('previousStepName', this.oldPageName, true);
        }
    
        if (this.oldPage !== this.pageId) {
            this.trackService.addStepsInfo("'stepBetweenName'", '', true);
            this.trackService.addStepsInfo("'stepNumber'", this.pageId, true);
            this.trackService.addStepsInfo("'stepName'", this.currentPageName, true);
            this.trackService.pushEventTracking("'siteSection'", 'Product');
            this.trackService.pushEventTracking("'pageName'", "QB Property | "+this.currentPageName );
            this.trackService.cleanData();

          if(this.pageId=='01.'){
            this.trackService.addBusinessEvent('buisnessEvent', 'Start process');
            this.trackService.pushEventTracking('user.type', 'Customer')
            this.trackService.pushEventTracking('user.loginStatus', 'Not logged in' )
          }
        }
        
        this.oldPage = this.pageId;
        this.oldPageName = this.currentPageName;
      }
    
    }
  }